import { batch, useDispatch, useSelector } from 'react-redux'
import { useEffect, useMemo } from 'react'
import { useDashboardTableSelector } from 'features/dashboard/utils/hooks/useDashboardTableSelector'
import { DashboardTypes } from 'features/Codes'
import { useDashboardTableActions } from 'features/dashboard/utils/hooks/useDashboardTableActions'

import { MetricColumns } from '../../../Columns'

const excludes = ['name', 'text', 'status', 'createdDate', 'updatedDate']

const useDefaultSort = columns => {
  const dispatch = useDispatch()
  const { type, filterEnabled } = useSelector(state => state.dashboard.common)
  const {
    sort: { name: sortName },
  } = useDashboardTableSelector()
  const { setPage, setSort } = useDashboardTableActions()
  const defaultSortName = useMemo(
    () => (type === DashboardTypes.KEYWORD ? 'text' : 'name'),
    [type]
  )
  const invisible = useMemo(
    () => !excludes.includes(sortName) && !columns.includes(sortName),
    [columns, sortName]
  )
  const disabled = useMemo(
    () => sortName in MetricColumns && !filterEnabled,
    [sortName, filterEnabled]
  )
  useEffect(() => {
    if (invisible || disabled) {
      batch(() => {
        dispatch(
          setSort({
            name: defaultSortName,
            order: 'asc',
          })
        )
        dispatch(setPage(0))
      })
    }
  }, [dispatch, invisible, disabled, defaultSortName, setPage, setSort])
}
export default useDefaultSort
